<script>
// Utils
import get from 'lodash/get';
import { eligibleProp } from '../utils/props-utils';
import { verticalScrollIntoViewSmoothFallback } from '../utils/scroll-utils';

// Types
import { scrollVerticalAlignment } from '../types/ScrollOnEvent.types';

// Vuex
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'ScrollOnEvent',
    props: {
        eventInstance: {
            type: Object,
            required: true
        },
        eventName: {
            type: String,
            required: true
        },
        verticalAlignment: {
            type: String,
            default: scrollVerticalAlignment.START,
            validator: eligibleProp(scrollVerticalAlignment)
        },
        marginOfError: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            $scrollEl: null
        }
    },
    mounted: function () {
        const { eventInstance, eventName } = this.$props;
        this.$scrollEl = get(this.$slots, ['default', '0', 'elm']);
        this.$scrollEl && eventInstance.$on(eventName, this.scrollToElement);
    },
    beforeDestroy: function () {
        const { eventInstance, eventName } = this.$props;
        eventInstance.$off(eventName);
    },
    computed: {
        ...mapState([
            'smoothScrollAvailable'
        ])
    },
    methods: {
        elNotVisible: function () {
            const { top, height } = this.$scrollEl.getBoundingClientRect();
            return Math.sign(top) > 0 
                ? window.innerHeight - (top + height) < -this.marginOfError
                : Math.abs(top) > this.marginOfError;
        },
        scrollToElement: function () {
            if (this.elNotVisible()) {
                if (this.smoothScrollAvailable) this.$scrollEl.scrollIntoView({ behavior: 'smooth', block: this.verticalAlignment });
                else verticalScrollIntoViewSmoothFallback(this.$scrollEl, { block: this.verticalAlignment })
            }
        }
    },
    render () {
       return this.$slots.default;
    }
}
</script>

